<template>
  <section class="p-appmanage">
    <el-row class="content-title">
      <h2 class="txt-gray">{{ $t('pages.apps.name') }} : {{ basicInfo.name }}</h2>
    </el-row>
    <el-tabs v-model="active">
      <el-tab-pane :label="$t('pages.apps.basic')" name="basic">
        <el-form :model="basicInfo" ref="basicForm" :rules="basicFromRule" label-width="160px" >
          <el-form-item :label="$t('pages.apps.name')" prop="name">
            <el-input v-model="basicInfo.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.apps.description')" prop="description">
            <el-input type="textarea" v-model="basicInfo.description"></el-input>
          </el-form-item>
          <el-form-item :label="$t('pages.apps.base_url')" prop="base_url">
            <el-input v-model="basicInfo.base_url"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.status')" prop="is_active">
            <el-checkbox v-model="basicInfo.is_active" :label="$t('common.active')"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('pages.apps.allow_create_user')" prop="allow_create_user">
            <el-checkbox v-model="basicInfo.allow_create_user" :label="$t('common.allow')"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateApp" type="primary">{{ $t('common.save') }}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane :label="$t('pages.apps.registration_settings')" name="configure">
        <el-form :model="authSetting" label-width="160px">
          <!-- <el-form-item prop="require_email" :label="$t('pages.appSetting.require_email')">
            <el-checkbox v-model="authSetting.require_email" :label="$t('common.yes')"></el-checkbox>
          </el-form-item> -->
          <el-form-item prop="allow_register" :label="$t('pages.appSetting.allow_register')">
            <el-checkbox v-model="authSetting.allow_register" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="verify_email" :label="$t('pages.appSetting.need_verify_email')">
            <el-checkbox v-model="authSetting.verify_email" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="verify_email_callback" :label="$t('pages.appSetting.verify_email_callback')">
            <el-input v-model="authSetting.verify_email_callback"></el-input>
          </el-form-item>
          <el-form-item prop="password_pattern" :label="$t('pages.appSetting.password_pattern')">
            <el-input v-model="authSetting.password_pattern"></el-input>
          </el-form-item>
          <el-form-item prop="password_description" :label="$t('pages.appSetting.password_description')">
            <el-input v-model="authSetting.password_description"></el-input>
          </el-form-item>
          <el-form-item prop="reset_password_callback" :label="$t('pages.appSetting.reset_password_callback')">
            <el-input v-model="authSetting.reset_password_callback"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateAuth" type="primary">{{ $t('common.save') }}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane :label="$t('pages.apps.login_settings')" name="login">
        <el-form :model="authSetting" label-width="180px">
          <el-form-item
            prop="allow_weixin_login"
            :label="$t('pages.appSetting.allow_weixin_login')"
          >
            <el-checkbox
              v-model="authSetting.allow_weixin_login"
              :label="$t('common.yes')"
            ></el-checkbox>
          </el-form-item>
          <el-form-item
            prop="force_weixin_login"
            :label="$t('pages.appSetting.force_weixin_login')"
          >
            <el-checkbox
              v-model="authSetting.force_weixin_login"
              :label="$t('common.yes')"
            ></el-checkbox>
          </el-form-item>
          <el-form-item
            v-if="authSetting.force_weixin_login"
            prop="ignore_weixin_login"
            :label="$t('pages.appSetting.ignore_weixin_login')"
          >
            <el-tag
              :key="tag"
              v-for="tag in authSetting.ignore_weixin_login || []"
              :closable="true"
              :close-transition="false"
              @close="handleClose(tag)"
              style="margin-right: 8px;"
              type="primary"
            >
              {{ tag }}
            </el-tag>
            <el-input
              v-if="inputVisible"
              style="width:160px;vertical-align:bottom"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              size="small"
              @click="showInput"
            >+ New Role</el-button>
          </el-form-item>
          <el-form-item prop="login_by_email" :label="$t('pages.appSetting.login_by_email')">
            <el-checkbox v-model="authSetting.login_by_email" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="login_lock" :label="$t('pages.appSetting.login_lock')">
            <el-checkbox v-model="authSetting.login_lock" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="login_max_attempts" :label="$t('pages.appSetting.login_max_attempts')">
            <el-input v-model="authSetting.login_max_attempts"></el-input>
          </el-form-item>
          <el-form-item prop="access_token_expiration" :label="$t('pages.appSetting.access_token_expiration')">
            <el-input v-model="authSetting.access_token_expiration"></el-input>
          </el-form-item>
          <el-form-item prop="refresh_token_expiration" :label="$t('pages.appSetting.refresh_token_expiration')">
            <el-input v-model="authSetting.refresh_token_expiration"></el-input>
          </el-form-item>
          <el-form-item prop="need_login_sms" :label="$t('pages.appSetting.need_login_sms')">
            <el-checkbox v-model="authSetting.need_login_sms" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="password_limit_reuse" :label="$t('pages.appSetting.password_limit_reuse')">
            <el-input v-model="authSetting.password_limit_reuse"></el-input>
          </el-form-item>
          <el-form-item prop="password_expiration" :label="$t('pages.appSetting.password_expiration')">
            <el-input v-model="authSetting.password_expiration"></el-input>
          </el-form-item>
          <el-form-item prop="revoke_on_logout" :label="$t('pages.appSetting.revoke_on_logout')">
            <el-checkbox v-model="authSetting.revoke_on_logout" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="revoke_on_change_pwd" :label="$t('pages.appSetting.revoke_on_change_pwd')">
            <el-checkbox v-model="authSetting.revoke_on_change_pwd" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateAuth" type="primary">{{ $t('common.save') }}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane
        class="email-template"
        :label="$t('pages.apps.email_template')"
        name="email"
      >
        <template v-for="(template, index) in emailTemplates">
          <el-row :key="index">
            <h4 class="txt-gray">{{$t(`pages.appSetting.${template.name}`)}}</h4>
          </el-row>
          <el-form
            :model="template"
            label-width="140px"
            :key="index"
          >
            <el-form-item :label="$t('pages.appSetting.type')">
              {{template.subject}}
            </el-form-item>
            <el-form-item :label="$t('pages.appSetting.content')">
              <code>{{template.body}}</code>
            </el-form-item>
            <el-form-item :label="$t('pages.appSetting.preview')">
              <div v-html="formatEmail(template.body)" class="view-block"></div>
            </el-form-item>
            <el-form-item>
              <el-button @click="editEmailTemplate(template)" type="primary">{{ $t('common.edit') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-tab-pane>

      <el-tab-pane :label="$t('pages.apps.email_server')" name="server">
        <el-form :model="smtpSetting" :rules="smptRules" label-width="160px">
          <el-form-item prop="host" :label="$t('pages.appSetting.host')">
            <el-input v-model="smtpSetting.host"></el-input>
          </el-form-item>
          <el-form-item prop="port" :label="$t('pages.appSetting.port')">
            <el-input v-model="smtpSetting.port"></el-input>
          </el-form-item>
          <el-form-item prop="username" :label="$t('common.username')">
            <el-input v-model="smtpSetting.username"></el-input>
          </el-form-item>
          <el-form-item prop="password" :label="$t('common.password')">
            <el-input v-model="smtpSetting.password" type="password"></el-input>
          </el-form-item>
          <el-form-item prop="use_ssl" :label="$t('pages.appSetting.use_ssl')">
            <el-checkbox v-model="smtpSetting.use_ssl" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="use_tls" :label="$t('pages.appSetting.use_tls')">
            <el-checkbox v-model="smtpSetting.use_tls" :label="$t('common.yes')"></el-checkbox>
          </el-form-item>
          <el-form-item prop="fromname" :label="$t('pages.appSetting.fromname')">
            <el-input v-model="smtpSetting.fromname"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateSmtp" type="primary">{{ $t('common.save') }}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-dialog v-model="editEmail" :title="$t('pages.appSetting.verify_email')">
      <el-form :model="emailTemplate" label-width="80px">
        <el-form-item prop="subject" :label="$t('pages.appSetting.type')">
          <el-input v-model="emailTemplate.subject"></el-input>
        </el-form-item>
        <el-form-item prop="body" :label="$t('pages.appSetting.content')">
          <el-input type="textarea" :rows="rows" v-model="emailTemplate.body" @keyup.enter.native="updateEmailTemplate"></el-input>
          <span class="tips-danger">{{ $t('pages.appSetting.email_notify') }}</span>
        </el-form-item>
        <el-form-item>
          <el-button @click="updateEmailTemplate" type="primary">{{ $t('common.save') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
  export default {
    data() {
      const stringValidator = (rule, value, cb) => {
        if (value.trim() === '') {
          cb(new Error(this.$t('rules.app_name')));
        } else {
          cb();
        }
      };
      return {
        rows: 8,
        active: 'basic',
        appId: this.$route.params.appId,
        editEmail: false,
        basicInfo: {
          name: '',
          description: '',
          base_url: '',
          is_active: false,
          allow_create_user: false,
        },
        authSetting: {
          require_email: false,
          verify_email: false,
          allow_register: false,
          reset_password_callback: '',
          verify_email_callback: '',
          password_pattern: '',
          password_description: '',
          allow_weixin_login: true,
          force_weixin_login: false,
          ignore_weixin_login: [],
          login_by_email: false,
          login_lock: false,
          login_max_attempts: 0,
          access_token_expiration: 0,
          refresh_token_expiration: 0,
          need_login_sms: false,
          password_limit_reuse: 0,
          password_expiration: null,
          revoke_on_logout: false,
          revoke_on_change_pwd: false,
        },
        smtpSetting: {
          host: '',
          port: '',
          username: '',
          password: '',
          use_ssl: false,
          use_tls: false,
          fromname: '',
        },
        emailTemplates: [],
        emailTemplate: {
          name: '',
          subject: '',
          body: '',
        },
        basicFromRule: {
          name: [
            { required: true, validator: stringValidator },
          ],
         /* base_url: [
            { required: true, message: this.$t('rules.base_url') },
          ], */
        },
        smptRules: {
          host: [
            { required: true, message: this.$t('rules.host') },
          ],
          port: [
            { required: true, message: this.$t('rules.port') },
          ],
          username: [
            { required: true, message: this.$t('rules.username') },
          ],
          password: [
            { required: true, message: this.$t('common.passwordPlaceholder') },
          ],
        },
        inputVisible: false,
        inputValue: '',
      };
    },
    watch: {
      // eslint-disable-next-line
      'authSetting.force_weixin_login'(newVal) {
        if (newVal) {
          this.authSetting.allow_weixin_login = true;
        }
      },
      // eslint-disable-next-line
      'authSetting.allow_weixin_login'(newVal) {
        if (!newVal) {
          this.authSetting.force_weixin_login = false;
        }
      },
    },
    methods: {
      formatEmail(html) {
        const ptn = /\bhref=".*"/;
        return html.replace(ptn, 'href="javascript:void(0);"');
      },
      copyExistValue(target, source) {
        const newObj = target;
        Object.keys(newObj).forEach((val) => {
          newObj[val] = source[val];
        });
      },
      fetchApp() {
        this.$api.fetchApp(this.appId).then((res) => {
          const app = res.data.application;
          this.copyExistValue(this.basicInfo, app);
        });
      },
      fetchAuthSetting() {
        this.$api.fetchAppAuthSetting(this.appId).then((res) => {
          const auth = res.data.auth_settings;
          this.copyExistValue(this.authSetting, auth);
        });
      },
      fetchAppSMTP() {
        this.$api.fetchAppSMTP(this.appId).then((res) => {
          const smtp = res.data.email_provider;
          this.copyExistValue(this.smtpSetting, smtp);
        });
      },
      fetchEmailTemplate() {
        this.$api.fetchEmailTemplate(this.appId).then((res) => {
          const templates = res.data.email_templates || [];
          this.emailTemplates = templates.filter(t => !!t);
        });
      },
      updateApp() {
        this.$api.editApp(this.appId, this.basicInfo).then(() => {
          this.fetchApp();
          this.$message(this.$t('pages.appSetting.update_success'));
        });
      },
      updateAuth() {
        this.$api.editAppAuthSetting(this.appId, this.authSetting).then(() => {
          this.fetchAuthSetting();
          this.$message(this.$t('pages.appSetting.update_success'));
        });
      },
      updateSmtp() {
        this.$api.updateAppSMTP(this.appId, this.smtpSetting).then(() => {
          this.fetchAppSMTP();
          this.$message(this.$t('pages.appSetting.update_success'));
        });
      },
      updateEmailTemplate() {
        this.$api.updateEmailTemplate(this.appId, this.emailTemplate).then(() => {
          this.editEmail = false;
          this.fetchEmailTemplate();
          this.$message(this.$t('pages.appSetting.update_success'));
        });
      },
      editEmailTemplate(template) {
        this.copyExistValue(this.emailTemplate, template);
        this.editEmail = true;
      },
      handleClose(tag) {
        this.authSetting.ignore_weixin_login.splice(
          this.authSetting.ignore_weixin_login.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        const { inputValue } = this;

        if (!this.authSetting.ignore_weixin_login) {
          this.authSetting.ignore_weixin_login = [];
        }

        if (inputValue) {
          this.authSetting.ignore_weixin_login.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
    },
    created() {
      this.fetchApp();
      this.fetchAuthSetting();
      this.fetchAppSMTP();
      this.fetchEmailTemplate();
    },
  };
</script>



// WEBPACK FOOTER //
// AppManage.vue?6291b2d7